import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const programSearchSchema = z.object({ shared: z.boolean().optional() });

export const Route = createFileRoute("/$lang/program/$programId")({
  component: React.lazy(() =>
    import("@/pages/program").then((mod) => ({
      default: mod.ProgramPage,
    })),
  ),
  validateSearch: (search) => programSearchSchema.parse(search),
});
